import items from '../../api/items'
import catDict from '../../config/category-dict'

export default {
    namespaced: true,
    state: {
        itemId: null,
        item: null,
        area: null,
        city: null,

        isLoaded: false,
    },
    mutations: {
        setItemId: function(state, itemId) {
            state.itemId = itemId
        },
        setItem: function(state, item) {
            state.item = item
            state.isLoaded = true
            state.isNotfound = item ? true : false
        },
        setArea: function(state) {
            let name = state.item.add_area
            state.area = catDict.getKey(name)
        },
        setCity: function(state) {
            state.city = state.item.city_rome
        },
    },
    getters: {
        itemId: state => {
            return state.itemId === void 0 ? null : state.itemId
        },
        addArea: state => {
            return !state.isLoaded ? 
                    null : state.item.add_area
        },
        addCity: state => {
            return !state.isLoaded ? null : state.item.add_city
        },
        name: state => {
            return !state.isLoaded ? '' : state.item.name
        },
        updateDate: state => {
            return !state.isLoaded ?
                    '' : state.item.update_y + '/' + 
                        state.item.update_m + '/' + 
                        state.item.update_d
        },
        isLoaded: state => {
            return state.isLoaded
        },
        item: state => {
            return state.item
        },
        isAccessViewable: state => {
            return state.isLoaded && state.item.data_type != 'type2' && state.item.data_type != 'type4' ? true : false
        },
        categoryKey: state => {
            return state.isLoaded ? catDict.getKey(state.item.job_category) : ''
        },
        jobKey: state => {
            return state.isLoaded ? catDict.getKey(state.item.job_type) : ''
        },
        isNotfound: state => {
            return state.isLoaded && state.item.name === void 0 ? true : false
        },
        isFound: state => {
            return state.isLoaded && state.item.name !== void 0 ? true : false
        },
        hasMap: state => {
            return state.isLoaded && 
                   state.item.data_type !== 'type2' &&
                   state.item.add_lat && 
                   state.item.add_long
        },
    },
    actions: {
        getItem: function({commit, getters}) {
            items.getItem(getters.itemId, res => {
                commit('setItem', res.data)
                commit('setArea')
                commit('setCity')
            })
        },

        getPreview: function({commit, getters}) {
            items.getPreview(getters.itemId, res => {
                commit('setItem', res.data)
                commit('setArea')
                commit('setCity')
            })
        }
    }
}
